var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToollogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.72 127.71 134.51 106.3 162.85 106.3 200.26 126.69 200.26 265.42 97.72 265.42 97.72 127.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31,265.41H97.72V127.71l1-1a72.86,72.86,0,0,1,50.74-20.39h0a72.88,72.88,0,0,1,50.75,20.39l1.05,1Zm-96.72-6.87h89.85V130.65a66.47,66.47,0,0,0-89.85,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.94 259.37 152.09 259.37 152.09 213.33 195.74 213.33 195.74 208.18 152.09 208.18 152.09 161.09 195.74 161.09 195.74 155.94 152.09 155.94 152.09 112.28 146.94 112.28 146.94 155.94 103.29 155.94 103.29 161.09 146.94 161.09 146.94 208.18 103.29 208.18 103.29 213.33 146.94 213.33 146.94 259.37",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,268.85H94.28V126.3l1-1a76.77,76.77,0,0,1,108.45,0l1,1ZM101.15,262h96.73V129.17a69.9,69.9,0,0,0-96.73,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,264.58c0-.22-.73-21.68-4.22-25.07s-7.29-.12-7.46,0l-.35-.42c.05,0,4.45-3.62,8.19,0S345,263.67,345,264.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,268.8c0-.26-2.38-25.77,6.93-36.46l.41.36c-9.16,10.52-6.82,35.79-6.79,36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42,266.1l-.55,0c0-.29,1.83-29-5-35.28l.37-.4C346.26,236.84,344.5,264.91,344.42,266.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,266.08h-.55c0-.79.23-19.39,5.51-22.42a3.73,3.73,0,0,1,3.42-.33c3.19,1.32,4.78,7,4.84,7.24l-.52.15c0-.06-1.58-5.67-4.53-6.89a3.25,3.25,0,0,0-2.94.3C345.53,247,345.31,265.89,345.31,266.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,266.1l-.54,0c0-.14.79-14.69-3.13-19.82a3.68,3.68,0,0,0-3.08-1.76c-2.57.18-4.73,4-4.75,4l-.48-.26c.1-.17,2.32-4.06,5.19-4.26a4.14,4.14,0,0,1,3.55,2C344.06,251.2,343.29,265.49,343.25,266.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.11,268.08c-.1-1.42-2.57-34.64,1.76-40.5l.44.33c-4.21,5.69-1.68,39.78-1.65,40.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,246.69s-2.6,1-1.83,3.22,9,6,9,6,3.44-3.15.28-8.28S354.94,245.08,354.87,246.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.58,242.39s2.76-.11,2.92,2.27-6,9-6,9-4.39-1.59-3.45-7.54S342.89,240.93,343.58,242.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.24,231s1.84-.2,1.69-1.32-7.17-4-11.31.66c0,0,2.65,4.56,6.49,4.62S341.24,231,341.24,231Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.67,228.26s-1.67.8-2.14-.23,4-7.2,10-5.42c0,0,.16,5.27-3.06,7.35S344.67,228.26,344.67,228.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,245.79s1.27-1-.1-1.53-8.11-.36-8.18,6.31c0,0,7.85,1.31,8.82-1.24S335.94,245.79,335.94,245.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,230.82s-1.27-1,.11-1.53,8.11-.36,8.18,6.31c0,0-7.85,1.31-8.82-1.24S351.94,230.82,351.94,230.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,236.19s-.12-1.25.89-.76,4.52,4.28.88,7.88c0,0-4.9-3.63-4-5.52S347.8,236.19,347.8,236.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,238s.77-1-.35-1.12-6.11,1.21-4.94,6.19c0,0,6.08-.45,6.34-2.52S334.8,238,334.8,238Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.35 284.58 334.48 284.58 332.23 261.73 357.6 261.73 355.35 284.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.12,
    y: 259.21,
    width: 27.6,
    height: 5.04,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.37,
    y: 289.46,
    width: 75.81,
    height: 81.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.23,
    y: 283.39,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.44,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.2,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.65,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.98,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.97,
    y: 295.89,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.86,
    y: 298.03,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.41,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.62,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.95,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.93,
    y: 295.89,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.83,
    y: 298.03,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.16,
    y: 296.61,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.05,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    transform: "translate(826.32 704) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.3,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    transform: "translate(774.81 704) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.84,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    transform: "translate(813.9 706.14) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.51,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    transform: "translate(787.24 706.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.72,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    transform: "translate(797.46 704) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.74,
    y: 338.9,
    width: 3.11,
    height: 28.35,
    transform: "translate(804.58 706.14) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    transform: "translate(762.39 704) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.88,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    transform: "translate(749.97 706.14) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.55,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    transform: "translate(723.31 706.14) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.76,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    transform: "translate(733.53 704) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.43,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    transform: "translate(706.87 704) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.77,
    y: 338.9,
    width: 3.11,
    height: 28.35,
    transform: "translate(740.65 706.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.44,
    y: 337.48,
    width: 3.11,
    height: 29.77,
    transform: "translate(713.99 704.72) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.8,283.39H341v92.75h75.29v5.51h5.08V283.39Zm-2.54,83.86H345.77V331.49h70.49Zm0-40.84H345.77V292.29h70.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.44,
    y: 289.46,
    width: 75.81,
    height: 81.59,
    transform: "translate(610.69 660.52) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.36,
    y: 375.14,
    width: 9.53,
    height: 6.5,
    transform: "translate(550.25 756.79) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.49,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    transform: "translate(675.18 622.27) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.73,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    transform: "translate(623.67 622.27) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.27,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    transform: "translate(662.76 624.41) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.94,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    transform: "translate(636.1 624.41) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.15,
    y: 295.89,
    width: 4.01,
    height: 30.49,
    transform: "translate(646.32 622.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.17,
    y: 298.03,
    width: 3.11,
    height: 28.35,
    transform: "translate(653.44 624.41) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.61,
    y: 295.89,
    width: 6.21,
    height: 30.49,
    transform: "translate(619.44 622.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.4,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    transform: "translate(607.02 624.41) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.07,
    y: 298.03,
    width: 6.21,
    height: 28.35,
    transform: "translate(580.36 624.41) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.28,
    y: 295.89,
    width: 4.01,
    height: 30.49,
    transform: "translate(590.58 622.27) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 298.03,
    width: 3.11,
    height: 28.35,
    transform: "translate(597.7 624.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.97,
    y: 296.61,
    width: 3.11,
    height: 29.77,
    transform: "translate(571.04 622.99) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.05,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.26,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.59,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.58,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.47,
    y: 338.9,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.92,
    y: 336.75,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.13,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.46,
    y: 338.9,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.45,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.96,
    y: 336.75,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.34,
    y: 338.9,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.67,
    y: 337.48,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.28,283.39v98.26h5.09v-5.51h75.28V283.39H265.28Zm5.09,48.1h70.49v35.76H270.37Zm0-39.2h70.49v34.12H270.37Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.15,319.26H256a4.65,4.65,0,0,1-4.68-5l11.36-199.55a5.32,5.32,0,0,1,5.25-5h135.2a4.65,4.65,0,0,1,4.68,5L396.4,314.27A5.32,5.32,0,0,1,391.15,319.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.15,319.26H256a4.65,4.65,0,0,1-4.68-5l11.36-199.55a5.32,5.32,0,0,1,5.25-5h135.2a4.65,4.65,0,0,1,4.68,5L396.4,314.27A5.32,5.32,0,0,1,391.15,319.26Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.76,114.72,393.4,314.27a5.32,5.32,0,0,1-5.25,5H253a4.65,4.65,0,0,1-4.68-5l2.87-50.48,8.49-149.07a5.32,5.32,0,0,1,5.25-5h135.2A4.65,4.65,0,0,1,404.76,114.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,176.42,393.4,314.27a5.33,5.33,0,0,1-5.24,5H253a4.64,4.64,0,0,1-4.68-5l7.85-137.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.04 168.08 270.28 168.08 272.04 137.07 389.8 137.07 388.04 168.08",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.48 122.83 390.61 122.83 390.06 132.61 383.92 132.61 384.48 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.3 122.83 383.43 122.83 382.88 132.61 376.74 132.61 377.3 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.12 122.83 376.25 122.83 375.7 132.61 369.56 132.61 370.12 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.94 122.83 369.07 122.83 368.52 132.61 362.38 132.61 362.94 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.76 122.83 361.89 122.83 361.34 132.61 355.2 132.61 355.76 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.58 122.83 354.71 122.83 354.16 132.61 348.02 132.61 348.58 122.83",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.38 129.18 272.49 129.18 272.73 125.03 292.61 125.03 292.38 129.18",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,160.33l-.08,1.31h-7.61l.06-1,4.56-4.14c1.18-1.08,1.43-1.74,1.47-2.4.07-1.08-.66-1.74-2.15-1.74a3.53,3.53,0,0,0-2.77,1.14l-1-.89a5.19,5.19,0,0,1,4-1.59c2.21,0,3.57,1.12,3.46,2.93-.06,1-.42,1.94-1.94,3.31l-3.43,3.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,160.69a1.08,1.08,0,0,1,1.09-1,.92.92,0,0,1,.94,1,1.08,1.08,0,0,1-1.06,1A1,1,0,0,1,327.94,160.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.59,159.06h-2l-.16,2.58H337l.16-2.58h-5.89l.06-1.06,5.83-6.88h1.64l-5.59,6.64h4.07l.14-2.28h1.42l-.14,2.28h2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,156.38c.21-3.43,2.17-5.38,4.65-5.38s4.2,1.95,4,5.38-2.17,5.38-4.64,5.38S341.46,159.81,341.66,156.38Zm7.13,0c.16-2.69-.91-4-2.56-4s-2.89,1.35-3.05,4,.9,4,2.57,4S348.63,159.07,348.79,156.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.76,156.38c.21-3.43,2.17-5.38,4.65-5.38s4.2,1.95,4,5.38-2.17,5.38-4.64,5.38S351.56,159.81,351.76,156.38Zm7.13,0c.16-2.69-.91-4-2.56-4s-2.89,1.35-3.05,4,.9,4,2.57,4S358.73,159.07,358.89,156.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,160.69a1.08,1.08,0,0,1,1.09-1,.92.92,0,0,1,.94,1,1.08,1.08,0,0,1-1.06,1A1,1,0,0,1,361.39,160.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.49,158.66c-.12,1.91-1.82,3.1-4.41,3.1s-4.12-1.19-4-3.1a2.81,2.81,0,0,1,2-2.54,2.21,2.21,0,0,1-1.35-2.27c.1-1.76,1.7-2.85,4-2.85s3.78,1.09,3.68,2.85a2.57,2.57,0,0,1-1.64,2.27A2.44,2.44,0,0,1,373.49,158.66Zm-1.51,0c.07-1.16-.92-1.88-2.6-1.88s-2.72.72-2.79,1.88.88,1.92,2.56,1.92S371.91,159.81,372,158.62Zm-4.75-4.71c-.06,1,.76,1.69,2.22,1.69s2.4-.65,2.46-1.69-.84-1.7-2.26-1.7S367.3,152.86,367.23,153.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.91,156.24c-.21,3.6-2.37,5.52-5.34,5.52a4.83,4.83,0,0,1-2.59-.62l.64-1.17a3.63,3.63,0,0,0,2,.5c2.15,0,3.59-1.34,3.75-4l0-.38a3.77,3.77,0,0,1-3.14,1.39c-2.11,0-3.54-1.25-3.43-3.19a3.65,3.65,0,0,1,3.94-3.32C381.62,151,383.12,152.89,382.91,156.24Zm-1.74-2c.07-1.08-.75-2-2.4-2a2.24,2.24,0,0,0-2.46,2c-.07,1.23.81,2,2.29,2A2.36,2.36,0,0,0,381.17,154.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.78,142.26l-.25,4.24h-.61l.22-3.72h-1l0-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,146.12a.44.44,0,0,1,.44-.41.37.37,0,0,1,.38.41.44.44,0,0,1-.43.42A.39.39,0,0,1,335.47,146.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.35,142.26l-.25,4.24h-.61l.22-3.72h-1l0-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.16,144.38c.08-1.38.87-2.17,1.88-2.17s1.69.79,1.61,2.17-.87,2.17-1.87,2.17S339.08,145.76,339.16,144.38Zm2.88,0c.06-1.09-.37-1.63-1-1.63s-1.17.54-1.23,1.63.37,1.63,1,1.63S342,145.46,342,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,144.38c.08-1.38.87-2.17,1.87-2.17s1.7.79,1.62,2.17-.88,2.17-1.87,2.17S343.15,145.76,343.24,144.38Zm2.88,0c.06-1.09-.37-1.63-1-1.63s-1.17.54-1.23,1.63.36,1.63,1,1.63S346.05,145.46,346.12,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.12,146.12a.44.44,0,0,1,.44-.41.37.37,0,0,1,.38.41.44.44,0,0,1-.43.42A.39.39,0,0,1,347.12,146.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,145.3c-.05.77-.73,1.25-1.78,1.25s-1.67-.48-1.62-1.25a1.13,1.13,0,0,1,.81-1,.9.9,0,0,1-.54-.92c0-.71.68-1.15,1.61-1.15s1.53.44,1.48,1.15a1,1,0,0,1-.66.92A1,1,0,0,1,352,145.3Zm-.61,0c0-.47-.37-.76-1-.76s-1.1.29-1.13.76.36.78,1,.78S351.37,145.76,351.4,145.28Zm-1.92-1.9c0,.42.31.68.9.68s1-.26,1-.68-.34-.68-.91-.68S349.51,143,349.48,143.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63,144.38c.08-1.38.87-2.17,1.88-2.17s1.69.79,1.61,2.17-.88,2.17-1.87,2.17S352.54,145.76,352.63,144.38Zm2.88,0c.06-1.09-.37-1.63-1-1.63s-1.17.54-1.23,1.63.37,1.63,1,1.63S355.44,145.46,355.51,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,144.62h-1.11l-.07,1.09h-.51l.06-1.09h-1.11l0-.48H358l.07-1.09h.51l-.07,1.09h1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,142.26l-.25,4.24h-.61l.22-3.72h-1l0-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,146.12a.43.43,0,0,1,.44-.41.38.38,0,0,1,.38.41.44.44,0,0,1-.43.42A.39.39,0,0,1,362.34,146.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.78,145.25c0,.72-.61,1.3-1.69,1.3a2.33,2.33,0,0,1-1.55-.52l.31-.48a1.83,1.83,0,0,0,1.27.46c.64,0,1-.29,1.05-.75s-.28-.74-1-.74h-.35l0-.43,1.16-1.31h-2.07l0-.52h2.83l0,.41-1.2,1.37C366.42,144.12,366.82,144.6,366.78,145.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.4,144.38c.08-1.38.88-2.17,1.88-2.17s1.7.79,1.62,2.17-.88,2.17-1.88,2.17S367.32,145.76,367.4,144.38Zm2.88,0c.07-1.09-.36-1.63-1-1.63s-1.17.54-1.24,1.63.37,1.63,1,1.63S370.22,145.46,370.28,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.48,144.38c.08-1.38.88-2.17,1.88-2.17s1.7.79,1.61,2.17-.87,2.17-1.87,2.17S371.4,145.76,371.48,144.38Zm2.88,0c.07-1.09-.37-1.63-1-1.63s-1.17.54-1.24,1.63.37,1.63,1,1.63S374.3,145.46,374.36,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37,146.12a.43.43,0,0,1,.44-.41.38.38,0,0,1,.38.41.44.44,0,0,1-.43.42A.38.38,0,0,1,375.37,146.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.8,144.38c.08-1.38.87-2.17,1.88-2.17s1.7.79,1.61,2.17-.87,2.17-1.87,2.17S376.72,145.76,376.8,144.38Zm2.88,0c.07-1.09-.37-1.63-1-1.63s-1.17.54-1.24,1.63.37,1.63,1,1.63S379.62,145.46,379.68,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.07,144.32a2.11,2.11,0,0,1-2.16,2.23,2,2,0,0,1-1.05-.25l.26-.47a1.5,1.5,0,0,0,.81.2,1.48,1.48,0,0,0,1.52-1.6v-.15a1.52,1.52,0,0,1-1.27.55,1.23,1.23,0,0,1-1.39-1.28,1.48,1.48,0,0,1,1.6-1.34C383.55,142.21,384.15,143,384.07,144.32Zm-.71-.8c0-.44-.3-.82-1-.82a.9.9,0,0,0-1,.82c0,.5.32.82.92.82A1,1,0,0,0,383.36,143.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,109.73C382,141.55,342.62,219.55,251.14,263.79l8.49-149.07a5.32,5.32,0,0,1,5.25-5Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,185.38H369.94a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2H384.2a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,384.72,185.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,185.29H344.86a2.13,2.13,0,0,0-2.1,2l-.29,5.13a1.86,1.86,0,0,0,1.87,2h14.79a2.14,2.14,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,359.65,185.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.91,199.64H369.13a2.13,2.13,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.15,2.15,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,383.91,199.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,199.54H344.05a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,358.84,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,199.64H319a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,333.75,199.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,199.73H293.89a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,308.67,199.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.59,199.82H268.8a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,283.59,199.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,218.77h-14a2.53,2.53,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,382.45,218.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38,218.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,357.38,218.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,218.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,332.29,218.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,218.89h-14a2.54,2.54,0,0,0-2.5,2.38l-.42,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.42-7.23A2.23,2.23,0,0,0,307.21,218.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,219h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24A2.21,2.21,0,0,0,267.4,231h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,282.12,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,292h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,353.2,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.12,292.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,328.12,292.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,292.23H289a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,303,292.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,292.35h-14a2.53,2.53,0,0,0-2.5,2.37L261,302a2.2,2.2,0,0,0,2.22,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,278,292.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,273.77h-14a2.54,2.54,0,0,0-2.5,2.38l-.36,6.29-.06.94-1,18.34a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l1-18.34.06-.94.36-6.29A2.23,2.23,0,0,0,379.32,273.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.25,273.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,354.25,273.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,273.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,329.16,273.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,273.9H290a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,304.08,273.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,274H265a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,279,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.36,255.44h-14a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,380.36,255.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,255.32h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,355.29,255.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.2,255.44h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,330.2,255.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,255.56h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,305.12,255.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,255.68H266a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,280,255.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,237.11h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,381.4,237.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,237h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,356.33,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,237.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,331.25,237.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,237.23h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,306.16,237.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,237.35H267a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,281.08,237.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.72,185.38H369.94a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2H384.2a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,384.72,185.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,185.29H344.86a2.13,2.13,0,0,0-2.1,2l-.29,5.13a1.86,1.86,0,0,0,1.87,2h14.79a2.14,2.14,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,359.65,185.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.91,199.64H369.13a2.13,2.13,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.15,2.15,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,383.91,199.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,199.54H344.05a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,358.84,199.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,199.64H319a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,333.75,199.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,199.73H293.89a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,308.67,199.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.59,199.82H268.8a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,283.59,199.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,218.77h-14a2.53,2.53,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,382.45,218.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38,218.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,357.38,218.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,218.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,332.29,218.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,218.89h-14a2.54,2.54,0,0,0-2.5,2.38l-.42,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.42-7.23A2.23,2.23,0,0,0,307.21,218.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,219h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24A2.21,2.21,0,0,0,267.4,231h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,282.12,219Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,292h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,353.2,292Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.12,292.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,328.12,292.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,292.23H289a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,303,292.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,292.35h-14a2.53,2.53,0,0,0-2.5,2.37L261,302a2.2,2.2,0,0,0,2.22,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,278,292.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,273.77h-14a2.54,2.54,0,0,0-2.5,2.38l-.36,6.29-.06.94-1,18.34a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l1-18.34.06-.94.36-6.29A2.23,2.23,0,0,0,379.32,273.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.25,273.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,354.25,273.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,273.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,329.16,273.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,273.9H290a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,304.08,273.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,274H265a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,279,274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.36,255.44h-14a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,380.36,255.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,255.32h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,355.29,255.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.2,255.44h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,330.2,255.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,255.56h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,305.12,255.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,255.68H266a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,280,255.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,237.11h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,381.4,237.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,237h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,356.33,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,237.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,331.25,237.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,237.23h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,306.16,237.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,237.35H267a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,281.08,237.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.2,194.51H369.42a1.86,1.86,0,0,1-1.88-2l.29-5.13a2.14,2.14,0,0,1,2.11-2h14.78a1.87,1.87,0,0,1,1.88,2l-.29,5.13A2.14,2.14,0,0,1,384.2,194.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.13,194.42H344.34a1.86,1.86,0,0,1-1.87-2l.29-5.13a2.13,2.13,0,0,1,2.1-2h14.79a1.87,1.87,0,0,1,1.88,2l-.3,5.13A2.14,2.14,0,0,1,359.13,194.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.39,208.77H368.61a1.86,1.86,0,0,1-1.88-2l.29-5.13a2.13,2.13,0,0,1,2.11-2h14.78a1.87,1.87,0,0,1,1.88,2l-.29,5.13A2.15,2.15,0,0,1,383.39,208.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.32,208.67H343.53a1.87,1.87,0,0,1-1.88-2l.3-5.13a2.14,2.14,0,0,1,2.1-2h14.79a1.87,1.87,0,0,1,1.88,2l-.3,5.13A2.13,2.13,0,0,1,358.32,208.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M333.23,208.77H318.45a1.87,1.87,0,0,1-1.88-2l.29-5.13a2.14,2.14,0,0,1,2.11-2h14.78a1.87,1.87,0,0,1,1.88,2l-.29,5.13A2.14,2.14,0,0,1,333.23,208.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.15,208.86H293.37a1.86,1.86,0,0,1-1.88-2l.29-5.13a2.14,2.14,0,0,1,2.11-2h14.78a1.87,1.87,0,0,1,1.88,2l-.29,5.13A2.14,2.14,0,0,1,308.15,208.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.07,209H268.28a1.87,1.87,0,0,1-1.88-2l.3-5.13a2.14,2.14,0,0,1,2.1-2h14.79a1.87,1.87,0,0,1,1.88,2l-.3,5.13A2.13,2.13,0,0,1,283.07,209Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,190h28.85a1.17,1.17,0,0,0,1.15-1.1h0a1,1,0,0,0-1-1.09H306.49a1.17,1.17,0,0,0-1.15,1.09h0A1,1,0,0,0,306.36,190Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,190h28.85a1.17,1.17,0,0,0,1.15-1.1h0a1,1,0,0,0-1-1.09H268.58a1.17,1.17,0,0,0-1.15,1.09h0A1,1,0,0,0,268.46,190Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,190.81h-3.83a1.79,1.79,0,0,1-1.8-1.92h0a2,2,0,0,1,2-1.92h3.82a1.79,1.79,0,0,1,1.81,1.92h0A2.06,2.06,0,0,1,275.89,190.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.69,190.77h-3.82a1.79,1.79,0,0,1-1.81-1.92h0a2.06,2.06,0,0,1,2-1.91h3.83a1.78,1.78,0,0,1,1.8,1.91h0A2,2,0,0,1,329.69,190.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,218.77h-14a2.53,2.53,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,382.45,218.77Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38,218.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,357.38,218.65Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,218.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,332.29,218.77Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,218.89h-14a2.54,2.54,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.22,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.42-7.23A2.23,2.23,0,0,0,307.21,218.89Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,219h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24A2.21,2.21,0,0,0,267.4,231h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,282.12,219Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,292h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,353.2,292Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.12,292.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,328.12,292.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,292.23H289a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,303,292.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,292.35h-14a2.53,2.53,0,0,0-2.5,2.37L261,302a2.2,2.2,0,0,0,2.22,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,278,292.35Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,273.77h-14a2.54,2.54,0,0,0-2.5,2.38l-.36,6.29-.06.94-1,18.34a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l1-18.34.06-.94.36-6.29A2.23,2.23,0,0,0,379.32,273.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.25,273.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,354.25,273.65Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,273.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,329.16,273.77Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,273.9H290a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,304.08,273.9Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,274H265a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,279,274Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.36,255.44h-14a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,380.36,255.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,255.32h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,355.29,255.32Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.2,255.44h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,330.2,255.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,255.56h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.24A2.21,2.21,0,0,0,305.12,255.56Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,255.68H266a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,280,255.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,237.11h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,381.4,237.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,237h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,356.33,237Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,237.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,331.25,237.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,237.23h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,306.16,237.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,237.35H267a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,281.08,237.35Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,185.38H370.94a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2H385.2a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,385.72,185.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,185.29H345.86a2.13,2.13,0,0,0-2.1,2l-.29,5.13a1.86,1.86,0,0,0,1.87,2h14.79a2.14,2.14,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,360.65,185.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.91,199.64H370.13a2.13,2.13,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.15,2.15,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,384.91,199.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,199.54H345.05a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,359.84,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.75,199.64H320a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.87,1.87,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,334.75,199.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.67,199.73H294.89a2.14,2.14,0,0,0-2.11,2l-.29,5.13a1.86,1.86,0,0,0,1.88,2h14.78a2.14,2.14,0,0,0,2.11-2l.29-5.13A1.87,1.87,0,0,0,309.67,199.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,199.82H269.8a2.14,2.14,0,0,0-2.1,2l-.3,5.13a1.87,1.87,0,0,0,1.88,2h14.79a2.13,2.13,0,0,0,2.1-2l.3-5.13A1.87,1.87,0,0,0,284.59,199.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.45,218.77h-14a2.53,2.53,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,383.45,218.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,218.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,358.38,218.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29,218.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,333.29,218.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,218.89h-14a2.54,2.54,0,0,0-2.5,2.38l-.42,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.42-7.23A2.23,2.23,0,0,0,308.21,218.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12,219h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24A2.21,2.21,0,0,0,268.4,231h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,283.12,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.2,292h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,354.2,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,292.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,329.12,292.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,292.23H290a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.54,2.54,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,304,292.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,292.35h-14a2.53,2.53,0,0,0-2.5,2.37L262,302a2.2,2.2,0,0,0,2.22,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,279,292.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,273.77h-14a2.54,2.54,0,0,0-2.5,2.38l-.36,6.29-.06.94-1,18.34a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l1-18.34.06-.94.36-6.29A2.23,2.23,0,0,0,380.32,273.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,273.65h-14a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,355.25,273.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.16,273.77h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.21,2.21,0,0,0,2.23,2.38h14a2.55,2.55,0,0,0,2.5-2.38l.41-7.23A2.22,2.22,0,0,0,330.16,273.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,273.9H291a2.53,2.53,0,0,0-2.5,2.37l-.42,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.42-7.24A2.22,2.22,0,0,0,305.08,273.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,274H266a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,280,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.36,255.44h-14a2.54,2.54,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,381.36,255.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,255.32h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,356.29,255.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2,255.44h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,331.2,255.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.12,255.56h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,306.12,255.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,255.68H267a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.23,2.23,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,281,255.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,237.11h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.22,2.22,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,382.4,237.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.33,237h-14a2.55,2.55,0,0,0-2.5,2.38l-.41,7.23a2.22,2.22,0,0,0,2.23,2.38h14a2.54,2.54,0,0,0,2.5-2.38l.41-7.23A2.21,2.21,0,0,0,357.33,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,237.11h-14a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,332.25,237.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.16,237.23h-14a2.55,2.55,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.53,2.53,0,0,0,2.5-2.37l.41-7.24A2.21,2.21,0,0,0,307.16,237.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.08,237.35H268a2.53,2.53,0,0,0-2.5,2.37l-.41,7.24a2.21,2.21,0,0,0,2.23,2.37h14a2.55,2.55,0,0,0,2.5-2.37l.41-7.24A2.22,2.22,0,0,0,282.08,237.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.42,360.26s-6.18,1.34-8.82,0-1.65-21-4.35-21.38c-6.2-.94-5.14,25.13-2.5,30.63S98,372.66,98,372.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.42,360.26s-6.18,1.34-8.82,0-1.65-21-4.35-21.38c-6.2-.94-5.14,25.13-2.5,30.63S98,372.66,98,372.66Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,406.5S88.78,273.36,99.7,271.83s13.56,45.41,9.34,133Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,406.5S88.78,273.36,99.7,271.83s13.56,45.41,9.34,133Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.1 396.66 121.03 396.66 118.03 419.64 88.1 419.64 85.1 396.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78,315.47s10,.87,10.25,0,.3-19.71,4.52-18.6,2.37,23.8,0,26.44-14.77,4.06-14.77,4.06S107.12,319,108.78,315.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78,315.47s10,.87,10.25,0,.3-19.71,4.52-18.6,2.37,23.8,0,26.44-14.77,4.06-14.77,4.06S107.12,319,108.78,315.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,394.34q-1.05-15.19-1.93-30.39t-1.49-30.42q-.64-15.21-.84-30.45c-.06-5.07-.06-10.15.08-15.24.08-2.54.18-5.08.41-7.63.11-1.27.25-2.54.49-3.82a11.52,11.52,0,0,1,.49-1.92l.22-.49a3.38,3.38,0,0,1,.36-.51,1.14,1.14,0,0,1,.36-.25.85.85,0,0,1,.59,0,1.22,1.22,0,0,1,.58.53,6.67,6.67,0,0,1,.69,1.94c.15.64.27,1.27.37,1.9.21,1.27.36,2.54.5,3.8.27,2.54.47,5.07.64,7.61.35,5.07.58,10.14.78,15.21q.57,15.23.77,30.45t.26,30.45q0,15.22-.12,30.45-.12-15.23-.37-30.44t-.54-30.44c-.25-10.15-.48-20.29-.91-30.43-.21-5.07-.46-10.13-.82-15.19-.18-2.52-.39-5.05-.66-7.56-.14-1.26-.3-2.51-.51-3.75-.1-.61-.21-1.23-.36-1.83a6.23,6.23,0,0,0-.56-1.63c0-.11-.13-.15-.08-.13s.18,0,.09,0l-.18.26-.17.38a11.92,11.92,0,0,0-.45,1.76c-.23,1.22-.38,2.47-.49,3.72-.23,2.51-.34,5-.42,7.57-.16,5.06-.17,10.14-.13,15.21.07,10.14.39,20.28.7,30.42s.75,20.29,1.2,30.42S101.93,384.2,102.47,394.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,319.94c1.29-.12,2.57-.2,3.85-.35s2.55-.25,3.81-.47a18,18,0,0,0,1.83-.4c.56-.13,1.23-.52,1-.58a12.49,12.49,0,0,1,0-2c0-.65.08-1.3.14-1.94.23-2.57.53-5.13.93-7.68a72.76,72.76,0,0,1,1.46-7.6c-.14,1.28-.25,2.56-.35,3.84l-.35,3.85-.7,7.68a34.92,34.92,0,0,0-.2,3.74v.13a2.44,2.44,0,0,1,0,.27,1,1,0,0,1-.21.41,1.54,1.54,0,0,1-.53.4,4.59,4.59,0,0,1-1,.35,12.31,12.31,0,0,1-2,.32A46.78,46.78,0,0,1,110,319.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,324.3l4.25-.95c1.41-.29,2.83-.6,4.23-.93a31.76,31.76,0,0,0,4.07-1.17c.13-.06.29-.16.25-.15a1.45,1.45,0,0,0,.16-.37,7.16,7.16,0,0,0,.25-1c.13-.69.22-1.4.31-2.11.33-2.85.49-5.74.7-8.62l.29-4.33.33-4.34c.17,2.9.19,5.8.15,8.7s-.17,5.8-.48,8.71c-.09.73-.19,1.45-.34,2.18a8.1,8.1,0,0,1-.3,1.12,2.56,2.56,0,0,1-.29.61,1.55,1.55,0,0,1-.63.45,25,25,0,0,1-4.32,1.06C115.8,323.67,112.93,324.06,110,324.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.34,363.9a24,24,0,0,1-7.6-.88,6.14,6.14,0,0,1-.94-.44,1.53,1.53,0,0,1-.46-.43,2.18,2.18,0,0,1-.26-.5,10,10,0,0,1-.54-1.91,38.13,38.13,0,0,1-.48-3.81c-.2-2.54-.28-5.08-.26-7.62s.1-5.07.32-7.6l.25,3.8.2,3.78c.16,2.53.27,5,.48,7.55.1,1.26.23,2.51.42,3.73a9.33,9.33,0,0,0,.42,1.75,1.42,1.42,0,0,0,.16.35.59.59,0,0,0,.21.21,3.71,3.71,0,0,0,.76.42,18.18,18.18,0,0,0,3.58,1C91.83,363.55,93.09,363.72,94.34,363.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.28,343.09c.14,1.47.23,3,.36,4.43l.3,4.43c.21,2.95.38,5.91.61,8.85.12,1.47.24,2.94.43,4.39a11.07,11.07,0,0,0,.4,2.06c.16.58.75.9,1.37,1.22a18.2,18.2,0,0,0,4.2,1.14c1.45.28,2.92.45,4.39.61a25.72,25.72,0,0,1-8.89-1,5.23,5.23,0,0,1-1.07-.56,2,2,0,0,1-.8-1,11.22,11.22,0,0,1-.53-2.27c-.23-1.49-.36-3-.49-4.45-.22-3-.35-5.93-.39-8.9S82.14,346.05,82.28,343.09Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.54,401.05l26.56-2.32V359.16h9.34v39.56l26.65,2.33a4.58,4.58,0,0,1,4.14,4.56v3.54H139.4v-3.54A4.58,4.58,0,0,1,143.54,401.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.54,401.05l26.56-2.32V359.16h9.34v39.56l26.65,2.33a4.58,4.58,0,0,1,4.14,4.56v3.54H139.4v-3.54A4.58,4.58,0,0,1,143.54,401.05Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.63,413.54a6.11,6.11,0,1,0,6.11-6.11A6.11,6.11,0,0,0,201.63,413.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,413.54a6.11,6.11,0,1,1-6.11-6.11A6.1,6.1,0,0,1,148,413.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,330h4.29a4.13,4.13,0,0,1,4.13,4.13v32.12a0,0,0,0,1,0,0H168.49a0,0,0,0,1,0,0V334.16A4.13,4.13,0,0,1,172.63,330Z",
    transform: "translate(349.54 696.31) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,330h4.29a4.13,4.13,0,0,1,4.13,4.13v32.12a0,0,0,0,1,0,0H168.49a0,0,0,0,1,0,0V334.16A4.13,4.13,0,0,1,172.63,330Z",
    transform: "translate(349.54 696.31) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22,261s2.88,57.68,15.3,67.61H149.24S137.39,309,136.51,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22,261s2.88,57.68,15.3,67.61H149.24S137.39,309,136.51,261Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,323.85H205a5,5,0,0,1,5,5v4.56a0,0,0,0,1,0,0h-68.9a0,0,0,0,1,0,0v-4.56A5,5,0,0,1,146.14,323.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.52,
    y: 328.63,
    width: 74.14,
    height: 4.78,
    rx: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.52,
    y: 328.63,
    width: 74.14,
    height: 4.78,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,273.65h21.28c6.23,0,10.74-5.6,10.06-12.51l-.91-9.23c-.68-6.91-6.29-12.51-12.52-12.51H130.8c-6.23,0-10.73,5.6-10.05,12.51l.91,9.23C122.34,268.05,127.94,273.65,134.18,273.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,261.14l6,.7s3.93-1.75,4-1.9,5.25,1.9,5.25,1.9l1,3.75s-7.41.79-8.81,0l-7.92.35Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54,266.83H225.33c-2.37,0-5.59-5.78-8.13-11.32-2.32-5.08-4.08-9.94-4.08-9.94l2.49-6.16,2.46-6.09c4.72,3.26,10.52,25.3,10.52,25.3l19.95,2.62S249.1,266.83,248.54,266.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.52 261.14 246.43 267.52 249.4 267.52 249.4 261.14 247.52 261.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.52 261.14 246.43 267.52 249.4 267.52 249.4 261.14 247.52 261.14",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,255.51c-2.32-5.08-4.08-9.94-4.08-9.94l2.49-6.16C216.69,242.2,219,249.32,217.2,255.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.75,213.14s-2.34,9,.57,13c0,0-26.16.31-33.52-4.44s.91-28,11.67-31.52S229.09,195.5,221.75,213.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,383.79l-5.74,1.09s-31.4-75.26-36.4-75.47-55.91,23.19-68.67,10.21,5.69-44.24,5.69-44.24,30.69-4.38,33,2.55a48.61,48.61,0,0,1,1.3,6.22c.35,2.12.59,3.9.59,3.9h0c.95-.24,31.76-8.19,43.9,0C259.35,296.39,273.33,383.79,273.33,383.79Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56,322.74s2.08.05,34.27-1.45c0,0-6,55.29-8.6,85.42l6.72.38s27.07-78.3,26.82-88.55-12-13.25-12-13.25S208.84,318.54,184.56,322.74Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,322.75c.33,0,3.6-.05,28.72-1.19l-.49-7.24A141.59,141.59,0,0,1,184.59,322.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,321.29s-6,55.29-8.6,85.41l6.72.38s27.07-78.29,26.82-88.54-12-13.25-12-13.25a170.6,170.6,0,0,1-19,9,141.59,141.59,0,0,1-28.23,8.43c.33,0,3.6-.05,28.72-1.19Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,319.62c7.65,7.79,34.63,5.74,53.16,5.74l11.16-41.21-22.46,1.92s-.8-2-1.61-4.05c-.67-1.72-1.36-3.48-1.56-4.09-2.31-6.93-33-2.55-33-2.55S149.76,306.65,162.52,319.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,291.79l19.23-5.72s-.8-2-1.61-4.05C195.28,285.07,185.15,291.79,185.15,291.79Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.95 270.61 168.21 275.39 201.21 277.93 202.09 272.28 168.95 270.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.95 270.61 168.21 275.39 201.21 277.93 202.09 272.28 168.95 270.61",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.15,
    y: 270.19,
    width: 1.64,
    height: 8.35,
    transform: "translate(29 -16.86) rotate(5.87)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.95,
    y: 272.04,
    width: 7.24,
    height: 5.49,
    transform: "translate(18.01 -11.66) rotate(3.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.41,
    y: 271.09,
    width: 1.64,
    height: 8.35,
    transform: "translate(29.22 -18.94) rotate(5.87)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.54,391.67a11.68,11.68,0,0,0-4.2-.37h0s-5.29-2.05-11.88-12.31l-5.38.85a4.48,4.48,0,0,0-3.65,3.63,2.48,2.48,0,0,0,0,.77,31.61,31.61,0,0,0,1.05,3.81c1.14,3.94,5.2,12.14,5.2,12.14l.88-.38-3-7.76c-1-2.63,2.3-.47,4.08,2.07s4.26,5,10,2.64C289.28,394,291.91,392.56,289.54,391.67Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92,375.41s3.27,4.56,7.29,9.46,7.13,6.43,7.13,6.43-3.93,2.59-7,.53-9.76-10.72-13.91-8.36a11.11,11.11,0,0,1,.37-2.55C265.16,379.63,270.92,375.41,270.92,375.41Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,417.31a11.7,11.7,0,0,0-3.8-1.82h0s-4.23-3.79-6.77-15.71l-5.34-1.1a4.51,4.51,0,0,0-4.7,2.11,3,3,0,0,0-.3.71,32.24,32.24,0,0,0-.36,3.93c-.32,4.1.59,13.2.59,13.2l.95-.05,0-8.3c0-2.82,2.32.37,3.09,3.37s2.24,6.15,8.42,6C229.57,419.41,232.54,419,230.64,417.31Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,395.53S220.4,401,222.44,407s4.4,8.53,4.4,8.53-4.59,1-6.74-2-5.35-13.47-10.07-12.73a11,11,0,0,1,1.24-2.25C212.07,397.46,219,395.53,219,395.53Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,395.53S220.4,401,222.44,407s4.4,8.53,4.4,8.53-4.59,1-6.74-2-5.35-13.47-10.07-12.73a11,11,0,0,1,1.24-2.25C212.07,397.46,219,395.53,219,395.53Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.07,233.32s-3.18,19.11-6.86,24.35a5.61,5.61,0,0,1-.5.62c-2.85,3-6.34,9.46-8,12.7-.61,1.19-1,1.95-1,1.95l-32.91-1.44s1-6.39,2.08-12.88c.75-4.62,1.74-10.08,2.93-15.2.47-2,1-4,1.5-5.81a42.45,42.45,0,0,1,3.46-9,6.9,6.9,0,0,1,2.31-2.63s1.4-.13,3.82-.12h.18A80.68,80.68,0,0,1,209.93,230,69.34,69.34,0,0,1,218.07,233.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8,226.18s4.78,11.28,13.37,11.28,8.87-6.33,8.87-6.33S202.45,225.49,188.8,226.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,225.24c-5.72-1.54-8.67.57-11.94,5.74l7.41,3,6.11,17.7L208.08,236l5.1.17S212.53,228.7,199.71,225.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,225.24c-5.72-1.54-8.67.57-11.94,5.74l7.41,3,6.11,17.7L208.08,236l5.1.17S212.53,228.7,199.71,225.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,257.67a5.61,5.61,0,0,1-.5.62c-2.85,3-6.34,9.46-8,12.7-7.71-1-22.74-3.3-24.71-7.11-1.81-3.48-3.36-14-4.17-20.46.47-2,1-4,1.5-5.81l11.17-3.13s1.84,11.66,2.13,17.17C188.85,256.19,205.43,257.39,211.21,257.67Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.65,229.23c.06,2,1.2,2.5,1.2,2.5.42,3.73-4.77,13-4.77,13L194,228.15c4.64-1.85,5.68-7,5.87-10a15.18,15.18,0,0,0,0-2.38l8.67,5.45a29.92,29.92,0,0,0-1.94,3.8A10.57,10.57,0,0,0,205.65,229.23Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,220.54a31.44,31.44,0,0,0-1.54,4,11,11,0,0,0-.54,4.29c-4.87.38-6.8-10.37-6.8-10.37l0-.06a16.53,16.53,0,0,0-.24-2.38Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.82,197.61c8.37,2.56,9.7,7.87,7.68,16.69-2.52,11-7.25,17.95-17,12.45C191.21,219.29,199.9,193.37,213.82,197.61Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,212.18a18.17,18.17,0,0,0,1.38,4.21,2.43,2.43,0,0,1-2.5.28Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,209.93c-.19.69-.72,1.15-1.19,1s-.67-.8-.48-1.49.72-1.15,1.19-1S211.51,209.23,211.31,209.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62,208.42l1.68-.17S211.19,209.31,210.62,208.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,212.19c-.2.69-.73,1.15-1.19,1s-.68-.79-.49-1.49.73-1.15,1.19-1S220.16,211.5,220,212.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,210.68l1.67-.17S219.85,211.57,219.28,210.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,204.64a.38.38,0,0,1-.3-.16.37.37,0,0,1,.1-.51,4.89,4.89,0,0,1,4.37-.18.36.36,0,1,1-.3.66,4.2,4.2,0,0,0-3.67.13A.36.36,0,0,1,209,204.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.32,207.69a.37.37,0,0,1-.28-.13,3.74,3.74,0,0,0-2.83-1.58.36.36,0,0,1,0-.72,4.39,4.39,0,0,1,3.43,1.84.37.37,0,0,1,0,.51A.4.4,0,0,1,222.32,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36,208.94s6-5.69,7-11.18c0,0,18.67-1.72,14.35,15.38,0,0,6.18-14.47-8.12-19.19s-20.66,16.36-15.14,24.9C198.49,218.85,196.62,212.51,200.36,208.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,220.45h0a4.64,4.64,0,0,1-4.62-3.94.35.35,0,0,1,.31-.4.37.37,0,0,1,.41.31,3.86,3.86,0,0,0,3.92,3.3.37.37,0,0,1,0,.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,207.26a.24.24,0,0,0,.13.28l.06,0,8.52,2a3.71,3.71,0,0,0,2.15,4A4.48,4.48,0,0,0,215.5,212a3.1,3.1,0,0,0,.25-.56,1.42,1.42,0,0,1,1.11-.31.75.75,0,0,1,.43.5,3.72,3.72,0,0,0,2.16,3.93,4.48,4.48,0,0,0,5.73-1.55,3.64,3.64,0,0,0-1.72-5.17,4.48,4.48,0,0,0-5.73,1.55,4,4,0,0,0-.25.56,1.09,1.09,0,0,0-.43-.27,1.55,1.55,0,0,0-1.12.11,3.71,3.71,0,0,0-2.15-4,4.46,4.46,0,0,0-5.72,1.55,3.27,3.27,0,0,0-.34.74l-8.49-2A.27.27,0,0,0,198.91,207.26Zm19.29,3.31a3.91,3.91,0,0,1,5-1.36,3.19,3.19,0,0,1,1.51,4.52,3.89,3.89,0,0,1-5,1.35A3.17,3.17,0,0,1,218.2,210.57Zm-9.68-2a3.9,3.9,0,0,1,5-1.35,3.18,3.18,0,0,1,1.5,4.51,3.91,3.91,0,0,1-5,1.36A3.19,3.19,0,0,1,208.52,208.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.91,207.26a.24.24,0,0,0,.13.28l.06,0,8.52,2a3.71,3.71,0,0,0,2.15,4A4.48,4.48,0,0,0,215.5,212a3.1,3.1,0,0,0,.25-.56,1.42,1.42,0,0,1,1.11-.31.75.75,0,0,1,.43.5,3.72,3.72,0,0,0,2.16,3.93,4.48,4.48,0,0,0,5.73-1.55,3.64,3.64,0,0,0-1.72-5.17,4.48,4.48,0,0,0-5.73,1.55,4,4,0,0,0-.25.56,1.09,1.09,0,0,0-.43-.27,1.55,1.55,0,0,0-1.12.11,3.71,3.71,0,0,0-2.15-4,4.46,4.46,0,0,0-5.72,1.55,3.27,3.27,0,0,0-.34.74l-8.49-2A.27.27,0,0,0,198.91,207.26Zm19.29,3.31a3.91,3.91,0,0,1,5-1.36,3.19,3.19,0,0,1,1.51,4.52,3.89,3.89,0,0,1-5,1.35A3.17,3.17,0,0,1,218.2,210.57Zm-9.68-2a3.9,3.9,0,0,1,5-1.35,3.18,3.18,0,0,1,1.5,4.51,3.91,3.91,0,0,1-5,1.36A3.19,3.19,0,0,1,208.52,208.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.18,211.13a3.84,3.84,0,0,0-2.93-4.57c-2.68-.51-5.54,4.45.52,7.7C199.64,214.72,200.44,214,201.18,211.13Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,265.94a111.21,111.21,0,0,1,14.16-2.06c5.74-.26,12.17-.38,10.58,2.73l-23.34.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,265.94a111.21,111.21,0,0,1,14.16-2.06c5.74-.26,12.17-.38,10.58,2.73l-23.34.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.11,
    y: 265.95,
    width: 27,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.08,
    y: 249.81,
    width: 1.19,
    height: 13.43,
    transform: "translate(-87.15 112.94) rotate(-24.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.08,260.71l7.72,1.84a8.73,8.73,0,0,1,3.19-2.61,77.32,77.32,0,0,1,8.47-1.73l1.62,7.74s-10.84,1.1-11.7.88l-9.3-.89Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.09,225.94c-5.38,1.54-5.77,29.76-3.66,33.46s27.51,7.43,27.51,7.43l1.63-5.69s-21.08-7.31-21.42-7.89,1.38-16.73,1.38-19.93S181.09,225.94,181.09,225.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.52 259.94 204.38 267.83 206.57 267.52 208.02 260.45 205.52 259.94",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.52 259.94 204.38 267.83 206.57 267.52 208.02 260.45 205.52 259.94",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.6 419.64 241.88 419.64 240.95 273.57 248.54 273.57 247.6 419.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.54 273.8 248.39 296.88 247.61 419.64 241.89 419.64 241.1 296.88 240.95 273.8 248.54 273.8",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.54 273.8 248.39 297.14 241.1 297.14 240.95 273.8 248.54 273.8",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.33 419.64 302.61 419.64 292.33 273.57 299.92 273.57 308.33 419.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.33 419.64 302.61 419.64 292.83 280.68 292.33 273.8 299.92 273.8 300.33 280.68 308.33 419.64",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.33 280.33 292.83 280.33 292.33 273.8 299.92 273.8 300.33 280.33",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.88 419.64 181.16 419.64 189.57 273.57 197.16 273.57 186.88 419.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.16 273.8 196.65 280.68 186.88 419.64 181.16 419.64 189.15 280.68 189.56 273.8 197.16 273.8",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.56 273.8 197.16 273.8 196.65 280.33 189.15 280.33 189.56 273.8",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55,270H305.93a0,0,0,0,1,0,0v5a2.16,2.16,0,0,1-2.16,2.16H185.72a2.16,2.16,0,0,1-2.16-2.16v-5a0,0,0,0,1,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55,270H305.93a0,0,0,0,1,0,0v5a2.16,2.16,0,0,1-2.16,2.16H185.72a2.16,2.16,0,0,1-2.16-2.16v-5a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.55,
    y: 269.99,
    width: 122.38,
    height: 3.58,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.48,270.92H180a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H309.48a2,2,0,0,1,2,2h0A2,2,0,0,1,309.48,270.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.48,270.92H180a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H309.48a2,2,0,0,1,2,2h0A2,2,0,0,1,309.48,270.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11,263.28v2.35c0,.7-1.21,1.2-1.9,1.2H234.49c-.71,0-1.83-.5-1.83-1.2v-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11,263.28v2.35c0,.7-1.21,1.2-1.9,1.2H234.49c-.71,0-1.83-.5-1.83-1.2v-2.35Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11,263.28v2.35c0,.7-1.21,1.2-1.9,1.2H253.12c-.71,0-1.86-.5-1.86-1.2v-2.35Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,234.51l-6.51,29.65a2.31,2.31,0,0,1-2.11,1.78H255.67a1.54,1.54,0,0,1-1.34-2l6.51-29.33a2,2,0,0,1,2.12-1.46h35.58C299.5,233.17,300.1,233.55,299.88,234.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,234.51l-6.51,29.65a2.31,2.31,0,0,1-2.11,1.78H255.67a1.54,1.54,0,0,1-1.34-2l6.51-29.33a2,2,0,0,1,2.12-1.46h35.58C299.5,233.17,300.1,233.55,299.88,234.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,234.51l-6.51,29.65a2.31,2.31,0,0,1-2.11,1.78H256.88a1.54,1.54,0,0,1-1.34-2l6.51-29.33a2,2,0,0,1,2.12-1.46h34.37C299.5,233.17,300.1,233.55,299.88,234.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,253.52c1.66,0,3.36-1.78,3.79-4s-.56-4-2.23-4a2.47,2.47,0,0,0-.92.18,5.08,5.08,0,0,1-2.83,3.62c0,.06,0,.12,0,.18C276.29,251.74,277.29,253.52,279,253.52Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToollogo);
export default __webpack_public_path__ + "static/media/Toollogo.a1e0eefbc7c8379092d792c775d77392.svg";
export { ForwardRef as ReactComponent };